// extracted by mini-css-extract-plugin
export default {"card":"Modal_card__kkasi","header":"Modal_header__hERyX","moreInfo":"Modal_moreInfo__njfjs","drop":"Modal_drop__nIy1f","slide-in":"Modal_slide-in__T7WB1"};